import { Link } from 'react-router-dom';
import SeoHelmet from "@/components/SeoHelmet";
import Navbar from "@/components/Navbar";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#FAF9F6] dark:bg-[#0A0F1E] text-slate-900 dark:text-white font-body">
      <SeoHelmet title="Page Not Found | Alvaru" description="The page you're looking for doesn't exist." />
      <Navbar />
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
        <h1 className="text-6xl font-bold mb-4 font-heading">404</h1>
        <p className="text-xl text-slate-500 dark:text-slate-400 mb-8">Oops! The page you're looking for doesn't exist.</p>
        <Link to="/" className="bg-cyan-600 hover:bg-cyan-700 text-white px-8 py-4 rounded-xl font-bold font-heading transition-colors">
          Return to Home
        </Link>
      </div>
    </div>
  );
}
